import React from 'react'
import styles from './InitialPage.module.scss'
import documents from '../../image/InitialPage/require-title.png'
import Offers from '../../components/Offers/Offers'
import {phone} from '../../utils/data'


const InitialPage = ({isOpen}) => {
    return (
        <section className={styles.main} id='initial'>
            <div className={styles.overlay}>
            <div className={styles.container}>
                <h1 className={styles.title}><span>Кровельные работы любой&#160;сложности в&#160;Москве и области</span></h1>
                <div className={styles.box}>
                    <img className={styles.documents} src={documents} alt='документы'/>
                    <p className={styles.subtitle}>Все работы с гарантией по договору</p>
                </div>
                <Offers/>
                <p className={styles.text_gray}><span>Получите бесплатную развернутую консультацию</span> инженера по вашему вопросу в течение 15 минут</p>
                <div className={styles.box_button}>
                    <a className={styles.button} target='_blank' rel='noopener noreferrer' href={'https://wa.me/' + phone} aria-label='связаться вацап'>получить консультацию <span className={styles.glare}></span></a>
                </div>
            </div>
            </div> 
        </section>
    )
}

export default InitialPage